var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "bar" }, [
        _c(
          "div",
          { staticClass: "bar-btn", on: { click: _vm.handleDownload } },
          [_vm._v("APP内打开")]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }